const customStyles = () => {
  const styles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused  ? 'border-red-600' : 'border-grey-300',
      height: '2.5em',
      width: '9em',
      minHeight: '1.9em',
      borderColor: '#ced4da',
      borderRadius: '1rem',
      lineHeight: '1.5',
      outline:'none'
    }),
    valueContainer: base => ({
      ...base,
      margin: 0,
      height: '100%',
      padding: '0 0.5rem',
      transform: 'translateY(-5%)',
    }),
    indicatorSeparator: base => ({
      ...base,
      display: 'none',
    }),
    placeholder: base => ({
      ...base,
      fontSize: '0.8rem',
      color: "#bebebe"
    }),
    menu: styles => ({ ...styles, zIndex: 999, width: 'auto', minWidth: "100%", maxWidth: '87vw', }),
    menuList: styles => ({ ...styles, minWidth: '100%', maxWidth: '100%', whiteSpace: 'wrap', textOverflow: 'ellipsis' })
  };

  return styles;

}

const customStyles2 = () => {
  const styles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused  ? '0.2vh solid rgb(151, 196, 110)' : '0.1vh solid #d6d6d6',
      maxHeight: '5vh',
      minHeight: '5vh',
      borderColor: '#ced4da',
      borderRadius: '0.7vh',
      fontFamily: 'calibri',
      // lineHeight: '1.5',
      textAlign: 'left',
      boxSizing:'border-box',
      boxShadow: "none",
      fontSize: '1.5vh',
      'div':{
        margin:0,
        padding:'0 1vh',
      }
      // 'div:nth-child(1)':{
      //   padding:'0 1vh',
      //   boxSizing:'border-box',
      //   'div:nth-child(2)':{
      //     margin:'0'
      //   }
      // }
    }),
    ValueContainer: base => ({
      ...base,
      margin: 0,
      fontSize: '1.8vh',
      color:'red',
      padding: '0.8vh 1.8vh',
      outline: 'none',
      boxSizing: 'border-box',
      boxShadow: "none"
    }),
    indicatorSeparator: base => ({
      ...base,
      display: 'none',
      
    }),
    indicatorContainer: base =>({
      ...base,
      height: '40vh',
      padding: '0',
      alignItems: 'flex-end'
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      padding:'1vh',
      "svg": {
        height: '3vh',
        width: '3vh'
      },
      display: 'flex',
        alignItems:'center',
      boxSizing: 'border-box'
    }),
    placeholder: base => ({
      ...base,
      fontSize: '1.8vh',
      color: "#bebebe",
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      marginRight: '1vh',
      marginLeft:'1vh',
      display:'flex',
      alignItems:'center',
      maxHeight: '5vh',
      margin: '0'
    }),
    // menuList: base => ({
    //   ...base,
    //   position: 'absolute',
    //   overflow: 'visible'
    // }),
    // menu: base => ({
    //   ...base,
    //   fontSize: '0.75rem',
    //   width: '26em',
    // }),
    menu: styles => ({ 
      ...styles, 
      marginTop:'1vh',
      zIndex: 999, 
      width: 'auto', 
      minWidth: "100%", 
      maxWidth: '87vw', 
      overflow: 'visible', 
      position: 'absolute', 
      textAlign: 'left', 
      fontSize: '1vh',
      // border: '0.25vh solid grey',
      boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
      // outline:'0.25vh '
    }),
    menuList: styles => ({ ...styles, minWidth: '100%', maxWidth: '100%', whiteSpace: 'wrap', textOverflow: 'ellipsis', textAlign: 'left', fontSize: '1.5vh' })
  };
  return styles;
}

const customStylesSelectWrap = (width, containerWidth) => {
  const styles = {
    container: (base, state) => ({
      ...base,
      // minWidth: '20px',
      // width: '20px !important',
      maxWidth: '6rem'
    }),
    control: (base, state) => ({
      ...base,
      height: '100%',
      minHeight: '1.9em',
      borderColor: '#ced4da',
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0',
      borderRadius: '0.25rem',

      lineHeight: '1.5',
      textAlign: 'left',
      maxWidth: containerWidth !== undefined ? containerWidth : '100%',
      // marginTop: '0'
    }),
    valueContainer: base => ({
      ...base,
      margin: 0,
      height: '100%',
      padding: '0 0 0 0.2rem',
      // transform: 'translateY(-5%)',
    }),
    dropdownIndicator:base => ({
      ...base,
      padding: '8px 2px !important'
    }),
    indicatorSeparator: base => ({
      ...base,
      display: 'none',
    }),
    
    placeholder: base => ({
      ...base,
      fontSize: '0.8rem',
      color: "#bebebe",
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    }),
    input: base => ({
      ...base,
      height: '100%',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    // menuportal: base => ({
    //   ...base,
    //   zindex: 9999,
    //   backgroundColor: 'yellow'
    // }),
    // menu: base => ({
    //   ...base,
    //   fontSize: '0.75rem',
    //   width: '26em',
    // }),
    menu: styles => ({ ...styles, zIndex: 999, width: 'auto', minWidth: '100%', maxWidth: width, textAlign: 'left' }),
    menuList: styles => ({
      ...styles, zIndex: 999, width: width, minWidth: '100%', maxWidth: width, whiteSpace: 'wrap', textOverflow: 'ellipsis',
      // position: 'fixed !important',
      // backgroundColor:'white',
      // border: '1px solid rgb(238, 238, 238)',
      // borderRadius: '5px !important'
    })
  };
  return styles;
}

const customStyles3 = () => {
  const styles = {
    container: (base, state) => ({
      ...base,
      maxHeight: '100%',
      // marginTop: '0'

    }),
    control: (base, state) => ({
      ...base,
      height: '2.5em',
      minHeight: '1.9em',
      height: '100%',
      // maxHeight:'100%',
      borderColor: '#ced4da',
      borderRadius: '0.25rem',
      lineHeight: '1.5',
      textAlign: 'left'
      // marginTop: '0'
    }),
    valueContainer: base => ({
      ...base,
      margin: 0,
      height: '100%',
      // padding: '0 0.5rem',
      // transform: 'translateY(-5%)',
      maxHeight: '100%',
    }),
    indicatorSeparator: base => ({
      ...base,
      display: 'none',
    }),
    placeholder: base => ({
      ...base,
      fontSize: '0.8rem',
      color: "#bebebe",
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    }),
    // menuList: base => ({
    //   ...base,
    //   position: 'absolute',
    //   overflow: 'visible'
    // }),
    // menu: base => ({
    //   ...base,
    //   fontSize: '0.75rem',
    //   width: '26em',
    // }),
    menu: styles => ({ ...styles, zIndex: 999, width: 'auto', minWidth: "100%", maxWidth: '87vw', overflow: 'visible', position: 'absolute', textAlign: 'left' }),
    menuList: styles => ({ ...styles, minWidth: '100%', maxWidth: '100%', whiteSpace: 'wrap', textOverflow: 'ellipsis', textAlign: 'left' })
  };
  return styles;
}

const customStylesDynamic = (width, containerWidth) => {
  // console.log(containerWidth)
  const styles = {
    container: (base) => ({
      ...base,

    }),
    control: (base, state) => ({
      ...base,
      height: '2.47em',
      minHeight: '1.9em',
      borderColor: '#ced4da',
      borderRadius: '0.25rem',
      lineHeight: '1.5',
      textAlign: 'left',
      maxWidth: containerWidth !== undefined ? containerWidth : '100%',
    }),
    valueContainer: base => ({
      ...base,
      margin: 0,
      height: '100%',
      padding: '0 0.5rem',
      transform: 'translateY(-5%)',
    }),
    indicatorSeparator: base => ({
      ...base,
      display: 'none',
    }),
    placeholder: base => ({
      ...base,
      fontSize: '0.8rem',
      color: "#bebebe",
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    // menuportal: base => ({
    //   ...base,
    //   zindex: 9999,
    //   backgroundColor: 'yellow'
    // }),
    // menu: base => ({
    //   ...base,
    //   fontSize: '0.75rem',
    //   width: '26em',
    // }),
    menu: styles => ({ ...styles, zIndex: 999, width: 'auto', minWidth: '100%', maxWidth: width, textAlign: 'left' }),
    menuList: styles => ({
      ...styles, zIndex: 999, width: width, minWidth: '100%', maxWidth: width, whiteSpace: 'wrap', textOverflow: 'ellipsis',
      // position: 'fixed !important',
      // backgroundColor:'white',
      // border: '1px solid rgb(238, 238, 238)',
      // borderRadius: '5px !important'
    })
  };
  return styles;
}

const customStylesDynamicRad = (width, containerWidth) => {
  // console.log(containerWidth)
  const styles = {
    container: (base) => ({
      ...base,

    }),
    control: (base, state) => ({
      ...base,
      height: '2.47em',
      minHeight: '1.9em',
      borderColor: '#ced4da',
      borderRadius: '1rem',
      lineHeight: '1.5',
      textAlign: 'left',
      maxWidth: containerWidth !== undefined ? containerWidth : '100%',
    }),
    valueContainer: base => ({
      ...base,
      margin: 0,
      height: '100%',
      padding: '0 0.5rem',
      transform: 'translateY(-5%)',
    }),
    indicatorSeparator: base => ({
      ...base,
      display: 'none',
    }),
    placeholder: base => ({
      ...base,
      fontSize: '0.8rem',
      color: "#bebebe",
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    // menuportal: base => ({
    //   ...base,
    //   zindex: 9999,
    //   backgroundColor: 'yellow'
    // }),
    // menu: base => ({
    //   ...base,
    //   fontSize: '0.75rem',
    //   width: '26em',
    // }),
    menu: styles => ({ ...styles, zIndex: 999, width: 'auto', minWidth: '100%', maxWidth: width, textAlign: 'left' }),
    menuList: styles => ({
      ...styles, zIndex: 999, width: width, minWidth: '100%', maxWidth: width, whiteSpace: 'wrap', textOverflow: 'ellipsis',
      // position: 'fixed !important',
      // backgroundColor:'white',
      // border: '1px solid rgb(238, 238, 238)',
      // borderRadius: '5px !important'
    })
  };
  return styles;
}

const customStylesFilter = (width, containerWidth) => {
  // console.log(containerWidth)
  const styles = {
    container: (base) => ({
      ...base,

    }),
    control: (base, state) => ({
      ...base,
      height: '2.47em',
      minHeight: '1.9em',
      borderColor: '#ced4da',
      borderRadius: '1rem',
      lineHeight: '1.5',
      textAlign: 'left',
      maxWidth: containerWidth !== undefined ? containerWidth : '100%',
    }),
    valueContainer: base => ({
      ...base,
      margin: 0,
      height: '100%',
      padding: '0 0.5rem',
      transform: 'translateY(-5%)',
    }),
    indicatorSeparator: base => ({
      ...base,
      display: 'none',
    }),
    placeholder: base => ({
      ...base,
      fontSize: '0.8rem',
      color: "#bebebe",
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    // menuportal: base => ({
    //   ...base,
    //   zindex: 9999,
    //   backgroundColor: 'yellow'
    // }),
    // menu: base => ({
    //   ...base,
    //   fontSize: '0.75rem',
    //   width: '26em',
    // }),
    menu: styles => ({ ...styles, zIndex: 999, width: 'auto', minWidth: '100%', maxWidth: width, textAlign: 'left' }),
    menuList: styles => ({
      ...styles, zIndex: 999, width: width, minWidth: '100%', maxWidth: width, whiteSpace: 'wrap', textOverflow: 'ellipsis',
      // position: 'fixed !important',
      // backgroundColor:'white',
      // border: '1px solid rgb(238, 238, 238)',
      // borderRadius: '5px !important'
    })
  };
  return styles;
}

const customDropDown = () => {
  const styles = {
    'dropdown-toggle': (base, state) => ({
      ...base,
      backgroundColor: '#1976D2',
      borderRadius: '1.5em',
      marginRight: '0.3em',
      borderColor: '#1976D2',
    }),
    // backgroundColor: '#1976D2',
    // borderRadius: '1.5em',
    // marginRight: '0.3em',
    // borderColor: '#1976D2',
    // ":hover": {
    //   backgroundColor: 'red',
    // },
  };
  // const styles = `
  //   background-color: #1976D2;
  //   border-radius: 1.5em;
  //   margin-right: 0.3em;
  //   border-color: #1976D2;
  //   &:hover {
  //     background-color: red;
  //   }
  // `;
  return styles;
}

export {
  customStyles, customStyles2, customStylesDynamic, customDropDown, customStyles3, customStylesFilter, customStylesDynamicRad, customStylesSelectWrap
}